import React from 'react';

import BadgeContainer from '../../main/components/badge-container';
import BadgeBanner from '../../main/components/badge-banner';

export default ({
    src,
    className,
    disableMSIcon,
    disableIntelIcon,
    customMessage,
    showFor,
    containerClassName,
    intelSrc,
}) => {
    return (
        <BadgeBanner className={containerClassName} showFor={showFor}>
            {disableIntelIcon ? null : (
                <BadgeContainer
                    key="intel"
                    className="intel-badge"
                    src={intelSrc}
                    customMessage={['Intel® Core™ Processors.']}
                />
            )}
            {disableMSIcon ? null : (
                <BadgeContainer
                    className={`ms-badge${className ? ' ' + className : ''}`}
                    src={src}
                    customMessage={customMessage}
                />
            )}
        </BadgeBanner>
    );
};
